/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BannerBanneridLangs200,
  GetApiV1BannerBanneridLangs401,
  GetApiV1BannerBanneridLangs404,
  GetApiV1BannerBanneridLangs500,
  GetApiV1BannerBanneridLangsPathParams,
  GetApiV1BannerBanneridLangsQueryParams,
  GetApiV1BannerBanneridLangsQueryResponse,
} from "../../types/bannerIdiomasController/GetApiV1BannerBanneridLangs.ts";
import { bannerLangViewModelPaginatedResponseSchema } from "../bannerLangViewModelPaginatedResponseSchema.ts";

export const getApiV1BannerBanneridLangsPathParamsSchema = z.object({
  bannerId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1BannerBanneridLangsPathParams>;

export const getApiV1BannerBanneridLangsQueryParamsSchema = z.object({
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1BannerBanneridLangsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BannerBanneridLangs200Schema = z.lazy(
  () => bannerLangViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1BannerBanneridLangs200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BannerBanneridLangs401Schema =
  z.any() as unknown as ToZod<GetApiV1BannerBanneridLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1BannerBanneridLangs404Schema =
  z.any() as unknown as ToZod<GetApiV1BannerBanneridLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BannerBanneridLangs500Schema =
  z.any() as unknown as ToZod<GetApiV1BannerBanneridLangs500>;

export const getApiV1BannerBanneridLangsQueryResponseSchema = z.lazy(
  () => getApiV1BannerBanneridLangs200Schema,
) as unknown as ToZod<GetApiV1BannerBanneridLangsQueryResponse>;
